@if (notesList.length) {
  <ul class="mta">
    @for (note of notesList; track note; let i = $index) {
      @if (activeNote === i) {
        <li class="am-flex-column gap-xxs pt-s pb-s pr-m pl-m b-grey"
           [class.bg-dim-red]="note.type === 'reject'"
           [class.b-red]="     note.type === 'reject'"
           [class.color-red]=" note.type === 'reject'"

           [class.bg-grey]="        note.type === 'note'"
           [class.b-grey]="         note.type === 'note'"
           [class.color-secondary]="note.type === 'note'">
          <h3 class="text-m text-450">{{ note.title }}</h3>
          @if (note.comment) { <span class="text-s">{{ note.comment }}</span> }
        </li>
      }
    }
  </ul>
}
@if (notesList.length > 1) {
  <div class="am-flex-center gap-xxs">
    @for (note of notesList; track note; let k = $index) {
      <span (click)="activeNote = k" class="circle-10"
            [class.bg-red]="      activeNote === k && note.type === 'reject'"
            [class.bg-dark-red]=" activeNote !== k && note.type === 'reject'"
            [class.bg-secondary]="activeNote === k && note.type === 'note'"
            [class.bg-grey]="     activeNote !== k && note.type === 'note'">
      </span>
    }
  </div>
}
